import { action, observable } from "mobx";
import * as DocumentManagement from "../DocumentManagement";
import { InputType } from "../Shared";
import { Strings } from "../Stores/StringsStore";
import * as Utilities from "../Utilities";
import { AppStore, IWizardStore, WizardStore } from "./AppStore";
import { DocumentStoreImpl } from "./DocumentStore";


export class HierarchyMetaValuesWizardStore extends WizardStore implements IWizardStore {

	@observable searchTerm: string;

	constructor(public documentStore: DocumentStoreImpl) {
		super();
		let uiLang = Utilities.getUiLanguage();
		if (!uiLang) {
			uiLang = AppStore.context.userInterfaceLanguages[0].name;
		}
		this.language = uiLang;
	}

	language: string;

	/**
  * Open the wizard for adding meta data.
  */
	open = (): void => {
		this.wizardCaption = Strings.documentManagement.documentEdit.addHierarchicalMetaValueCaption;
		this.wizardInformation = Strings.documentManagement.documentEdit.addHierarchicalMetaValueText;
		this.documentStore.addMetaMode = true;
		this.isOpen = true;
	}

	onConfirmExternal = () => {

	}

	/**
   * Callback for confirming the wizard operation.
   */
	@action onConfirmWizard = () => {
		this.isOpen = false;
		if (this.documentStore.existingHierarchyMetaValue) {
			this.documentStore.existingHierarchyMetaValue.valueHierarchy.value = this.documentStore.selectedHierarchyMetaValue;
			this.documentStore.existingHierarchyMetaValue.isValid = this.documentStore.existingHierarchyMetaValue.valueHierarchy.isValid = true;
			this.documentStore.existingHierarchyMetaValue.validationMessage = this.documentStore.existingHierarchyMetaValue.valueHierarchy.validationMessage = null;
			this.documentStore.existingHierarchyMetaValue = null;
		}
		else {
			let value = new DocumentManagement.DocumentMetaValue();
			value.valueHierarchy = new DocumentManagement.InputHierarchy();
			value.valueHierarchy.value = this.documentStore.selectedHierarchyMetaValue;
			value.isValid = value.valueHierarchy.isValid = true;
			value.validationMessage = value.valueHierarchy.validationMessage = null;
			this.documentStore.model.metas.find(m => m.inputType === InputType.InputHierarchy).values.push(value);
		}
		this.documentStore.selectHierarchyMetaValueMode = false;
		this.documentStore.selectedHierarchyMetaValue = null;
		this.searchTerm = null;
		this.onConfirmExternal();
	}

	/**
	* Callback fro canceling the wizard operation.
	*/
	@action onCancelWizard = () => {
		this.isOpen = false;
		this.documentStore.selectHierarchyMetaValueMode = false;
		this.documentStore.selectedHierarchyMetaValue = null;
		this.searchTerm = null;
	}

}